<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_payment_method_banner.jpg')" alt="入出金方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <div class="sup-subtab-wrap">
          <router-link class="sup-subtab" to="/page/sup-deposit-bank">
            銀行振込
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-deposit-mtpay">
            Match Pay
          </router-link>
          <router-link class="sup-subtab sup-subtab--active" to="/page/sup-deposit-vega">
            VegaWallet
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-deposit-jeten">
            Jetonbank
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-deposit-usdt">
            USDT購入
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-deposit-crypto">
            仮想通貨
          </router-link>
        </div>
        <h1 class="sup-page-title">
          VegaWalletでの入金方法
        </h1>
        <div class="sup-steps-box">
          <!-- ステップ 1 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <p class="sup-step-desc">
              ホーム画面の「入金」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_bank1.jpg')" alt="ステップ1">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 2 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 「VegaWallet」を選択</p>
              <p>➋ 金額を選択または入力</p>
              <p>➌ VegaWalletの「Uから始まるユーザーID」と「パスワード」を入力</p>
              <p>➍ 「入金」をタップ</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_vega3.jpg')" alt="ステップ2-1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_vega4.jpg')" alt="ステップ2-2">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 3 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <p class="sup-step-desc">
              VegaWalletへログイン後、お手続きを完了すると「JPYウォレット」へ即時反映。
            </p>
            <p class="sup-step-caution">
              ※ご利用には事前にVegaWalletの口座開設および残高補充が必要です。
            </p>
            <p class="sup-step-caution">
              ※VegaWalletから勝WINへ初めてのご入金には、VegaWalletでの送付先登録が必要です。<br>
              送付先登録方法の詳細はVegaWallet公式サイトをご参照ください。<br>
              <a href="https://vega-wallet.com/whitelist/" target="_blank" rel="noopener" style="color:#978564;">https://vega-wallet.com/whitelist/</a>
            </p>
          </div>
        </div>
        <div class="sup-steps-box sup-steps-box--mt">
          <div class="sup-step">
            <p class="sup-step-num">
              ※VegaWalletの「Uから始まるユーザーID」の確認方法※
            </p>
            <p class="sup-step-desc">
              VegaWalletへログイン後、<br>
              ホーム画面に記載される「ベガID」が、Uから始まるユーザーIDです
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_vega1.jpg')" alt="VegaWallet ユーザーID確認">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
